import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3b64a662"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content-menu pc-content-menu"
};
import store from "@/store";
import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'navigation-menu',
  emits: ["hideMenu"],
  setup(__props, {
    emit: emits
  }) {
    var currentIndex = ref(0);
    const menuList = [{
      title: "首页",
      url: "/",
      name: "index"
    }, {
      title: "幸福心理课",
      url: "/course",
      name: "happinessPsychologyCourse"
    }, {
      title: "全民幸福社APP",
      url: "/app",
      name: "psychologyApp"
    }, {
      title: "文创周边",
      url: "/cultural",
      name: "culturalIndustries"
    }, {
      title: "关于我们",
      url: "/about",
      name: "aboutUs"
    }, {
      title: "加入我们",
      url: "/join",
      name: "joinUs"
    }];
    function clickMenu(index) {
      currentIndex.value = index;
      emits("hideMenu", true);
    }
    function clickShade() {
      emits("hideMenu", false);
    }
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", {
        class: "content pc-content",
        onTouchmove: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
        onClick: clickShade
      }, [_createElementVNode("div", _hoisted_1, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuList, (item, index) => {
        return _createVNode(_component_router_link, {
          key: index,
          to: item.url,
          class: _normalizeClass({
            'content-menu-item': true,
            'content-menu-item-active': _unref(store).getters.currentRouteName == item.name,
            'pc-content-menu-item': true,
            'pc-content-menu-item-active': _unref(store).getters.currentRouteName == item.name
          }),
          onClick: _withModifiers($event => clickMenu(index), ["stop"])
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
          _: 2
        }, 1032, ["to", "class", "onClick"]);
      }), 64))])], 32);
    };
  }
});